import './css/app.css';
import 'utils/lazysizes';
import { picoapp } from 'picoapp';
import ready from 'utils/ready';
import quickAdd from 'utils/quick-add';

import cartDrawer from 'layout/cart-drawer';
import cartTerms from 'layout/cart-terms';
import cartToast from 'layout/cart-toast';
import footer from 'layout/footer';
import header from 'layout/header';
import mobileNav from 'layout/mobile-nav';
import searchDrawer from 'layout/search-drawer';
import video from 'layout/video';
import completeTheLook from 'components/complete-the-look';
import completeTheLookForm from 'components/complete-the-look-form';
import completeTheLookModal from 'components/complete-the-look-modal';
import parallax from 'components/parallax';
import wishlistAddBtn from 'components/wishlist-add-btn';
// import wishlistCount from 'components/wishlist-count';
import quantity from 'components/quantity';
import videoGridItem from 'components/video-grid-item';
import geolocator from 'components/geolocator';

const app = picoapp({
  'cart-drawer': cartDrawer,
  'cart-terms': cartTerms,
  'cart-toast': cartToast,
  footer,
  header,
  'mobile-nav': mobileNav,
  'search-drawer': searchDrawer,
  video,
  'complete-the-look': completeTheLook,
  'complete-the-look-form': completeTheLookForm,
  'complete-the-look-modal': completeTheLookModal,
  parallax,
  quantity,
  wishlistAddBtn,
  'video-grid-item': videoGridItem,
  geolocator,
}, {
  cart: theme.cart,
});

ready(app.mount);

document.addEventListener('app:remount', () => app.mount());

quickAdd();

export default app;
